import React from 'react'
import styles from './tooltip.module.scss'

type DirectionType = 'left' | 'right' | 'top' | 'bottom'

type ToolTipProps = {
  title?: string
  direction: DirectionType
  zIndex?: number
  whiteSpace?: string
  children?: React.ReactNode
  isVisible: boolean
  top?: string
  bottom?: string
  left?: string
  right?: string
}

export const ToolTip = (props: ToolTipProps) => {
  const {
    title,
    direction,
    zIndex,
    whiteSpace,
    children,
    isVisible,
    top,
    bottom,
    left,
    right,
  } = props

  return (
    <>
      {isVisible && (
        <span
          className={styles.tooltipWrapper}
          style={{ top, bottom, left, right, position: 'absolute', zIndex }}
        >
          <div
            className={`${styles.tooltip} ${styles[direction]}`}
            style={{ whiteSpace }}
          >
            {title || children}
            <span className={`${styles.arrow} ${styles[direction]}`} />
          </div>
        </span>
      )}
    </>
  )
}
